import { render, staticRenderFns } from "./BottomNavbarComponent.vue?vue&type=template&id=5b2b7ce5&"
import script from "./BottomNavbarComponent.vue?vue&type=script&lang=js&"
export * from "./BottomNavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavbarComponent.vue?vue&type=style&index=0&id=5b2b7ce5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports